import { noAuthApi } from '@/shared/api/noAuthApi';
import { RecoveryFormData } from '@/features/RecoveryForm/model/types/recovery';
import { OtpChannel } from '@/shared/lib/otp/cooldowns';

interface ResetPassword {
  token: string;
  maxDeepLink: string | null;
  channel: OtpChannel;
  retryAfterSeconds: number;
  canResend: boolean;
  remainingAttempts: number;
}

interface ResetPasswordQuery extends RecoveryFormData {
  captcha: string;
  channel: OtpChannel;
}

export type ResendChannel = OtpChannel;

export interface ResendCodeQuery {
  registrationToken: string;
  channel: OtpChannel;
}

export interface ResendCodeResponse {
  channel: OtpChannel;
  retryAfterSeconds: number;
  canResend: boolean;
  remainingAttempts: number;
}

const recoveryApi = noAuthApi.injectEndpoints({
  endpoints: (build) => ({
    resetPassword: build.mutation<ResetPassword, ResetPasswordQuery>({
      query: (data) => ({
        url: '/v1/portal/reset-password/request',
        method: 'POST',
        body: data,
      }),
    }),
    resendRecoveryCode: build.mutation<ResendCodeResponse, ResendCodeQuery>({
      query: ({ registrationToken, channel }) => ({
        url: '/v1/portal/reset-password/resend-code',
        method: 'POST',
        body: {
          registrationToken,
          channel,
        },
      }),
    }),
  }),
});

export const { useResetPasswordMutation, useResendRecoveryCodeMutation } = recoveryApi;
